// extracted by mini-css-extract-plugin
export var errorsContainer = "_v5-1";
export var link = "_v5-0";